import React from 'react';
import uuidv4 from 'uuidv4';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import PopupState, { bindMenu, bindTrigger } from 'material-ui-popup-state';
import IconButton from '@material-ui/core/IconButton';
import Avatar from '@material-ui/core/Avatar';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Divider from '@material-ui/core/Divider';
import CardContent from '@material-ui/core/CardContent';
import DragHandleIcon from '@material-ui/icons/DragHandle';
import { Form } from 'formik';
import {
  SortableContainer,
  SortableElement,
  SortableHandle,
} from 'react-sortable-hoc';
import { BLOCK_TYPES } from 'constant/form-builder';
import TitleBlock from './RichTextBlock';
import QuestionBlock from './QuestionBlock';
import QuestionGroupBlock from './QuestionGroupBlock';
import QuestionsTableBlock from './QuestionsTableBlock';
import DividerBlock from './DividerBlock';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  card: {
    marginBottom: theme.spacing(2),
    borderRadius: 0,
    boxShadow: 'none',
    border: '1px solid #eee',
  },
  dragIcon: {
    cursor: 'move',
    display: 'block',
    margin: 'auto',
  },
}));

const blockTitle = {
  TITLE: 'Rich text Content',
  QUESTION_GROUP: 'Question group',
  QUESTION: 'Question',
  [BLOCK_TYPES.DIVIDER]: 'Divider',
  [BLOCK_TYPES.QUESTIONS_TABLE]: 'Questions table',
};

const blockSubtitle = {
  TITLE: 'Create rich text content with formatted text, links and images',
  QUESTION_GROUP: 'A group of related questions',
  QUESTION: 'Single question',
  [BLOCK_TYPES.DIVIDER]: 'Add Page break',
  [BLOCK_TYPES.QUESTIONS_TABLE]:
    'Use tabular layout of questions. Can be configured as column or rows layout',
};

const DragHandle = SortableHandle(({ classes }) => (
  <DragHandleIcon className={classes.dragIcon} />
));

const SortableItem = SortableElement(({ children, ...props }) => (
  <>{children}</>
));

const Block = ({ block, index, push, remove }) => {
  const classes = useStyles();
  const onDuplicate = (block, popupState) => {
    push({
      ...block,
      id: uuidv4(),
    });
    popupState.close();
  };

  return (
    <Card className={classes.card}>
      <DragHandle classes={classes} />
      <CardHeader
        title={blockTitle[block.type]}
        subheader={blockSubtitle[block.type]}
        avatar={<Avatar>{index + 1}</Avatar>}
        action={
          <PopupState variant="popover">
            {(popupState) => (
              <React.Fragment>
                <IconButton {...bindTrigger(popupState)}>
                  <MoreVertIcon />
                </IconButton>
                <Menu {...bindMenu(popupState)}>
                  <MenuItem onClick={() => onDuplicate(block, popupState)}>
                    Duplicate Section
                  </MenuItem>
                  <Divider />
                  <MenuItem
                    onClick={() => {
                      remove(index);
                      popupState.close();
                    }}
                  >
                    Delete section
                  </MenuItem>
                </Menu>
              </React.Fragment>
            )}
          </PopupState>
        }
      />
      <CardContent>
        {block.type === BLOCK_TYPES.TITLE && (
          <TitleBlock index={index} block={block} />
        )}
        {block.type === BLOCK_TYPES.QUESTION && (
          <QuestionBlock index={index} block={block} />
        )}
        {block.type === BLOCK_TYPES.QUESTION_GROUP && (
          <QuestionGroupBlock index={index} block={block} />
        )}
        {block.type === BLOCK_TYPES.DIVIDER && (
          <DividerBlock index={index} block={block} />
        )}
        {block.type === BLOCK_TYPES.QUESTIONS_TABLE && (
          <QuestionsTableBlock index={index} block={block} />
        )}
      </CardContent>
    </Card>
  );
};

const MemoBlock = React.memo(Block);

const SortableListContainer = SortableContainer(({ items, remove, push }) => (
  <div>
    {items.map((item, index) => (
      <SortableItem key={index} index={index}>
        <MemoBlock index={index} block={item} push={push} remove={remove} />
      </SortableItem>
    ))}
  </div>
));

const BlocksArray = ({ move, swap, push, insert, unshift, remove, form }) => {
  const blocks = form.values.blocks || [];
  return (
    <Form>
      {/*{form.values.blocks?.map((block, idx) => (*/}
      {/*  <MemoBlock classes={classes} index={idx} key={idx} block={block} push={push} pop={pop}  />*/}
      {/*))}*/}
      <SortableListContainer
        useDragHandle
        lockToContainerEdges
        lockAxis="y"
        onSortEnd={({ oldIndex, newIndex }) => {
          move(oldIndex, newIndex);
        }}
        items={blocks}
        push={push}
        remove={remove}
      />
    </Form>
  );
};

export default BlocksArray;
